export const LeftSidebarExpand: React.FC = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_625_602)">
      <mask id="mask0_625_602" maskUnits="userSpaceOnUse" x="0" y="0"
        width="20" height="20">
        <path d="M0 20H20V0H0V20Z" fill="white" />
      </mask>
      <g mask="url(#mask0_625_602)">
        <path
          d="M14.4788 9.52116C14.5252 9.56759 14.5621 9.62274 14.5873 9.68343C14.6124 9.74413 14.6254 9.8092 14.6254 9.87491C14.6254 9.94061 14.6124 10.0057 14.5873 10.0664C14.5621 10.1271 14.5252 10.1822 14.4788 10.2287L11.4787 13.2287C11.4088 13.2987 11.3197 13.3463 11.2227 13.3657C11.1256 13.385 11.025 13.3751 10.9336 13.3372C10.8422 13.2993 10.7641 13.2352 10.7091 13.1529C10.6542 13.0706 10.6249 12.9739 10.625 12.8749V6.87491C10.6249 6.77596 10.6542 6.67921 10.7091 6.59691C10.7641 6.51462 10.8422 6.45047 10.9336 6.41259C11.025 6.37472 11.1256 6.36482 11.2227 6.38414C11.3197 6.40347 11.4088 6.45115 11.4787 6.52116L14.4788 9.52116Z"
          fill="currentColor" />
        <path
          d="M5.98875 18.125V1.875M16.805 18.125H3.195C2.67875 18.125 2.18375 17.935 1.82 17.5962C1.64189 17.4342 1.49928 17.2371 1.40117 17.0172C1.30307 16.7973 1.2516 16.5595 1.25 16.3188V3.68125C1.25 2.68375 2.12 1.875 3.195 1.875H16.805C17.88 1.875 18.75 2.68375 18.75 3.68125V16.3188C18.75 17.3163 17.8788 18.125 16.805 18.125Z"
          stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_625_602">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)